import React, { useEffect, useState } from "react";
import { FaSearch } from "react-icons/fa";

function AdvanceSearch({ searchQuery = "", onSearchValue }) {
  const [SearchValue, setSearchValue] = useState("");
  const [error, setError] = useState(false);
  useEffect(() => {
    setSearchValue(searchQuery);
  }, [searchQuery]);
  const handleAdvanceSearch = () => {
    if (SearchValue.length >= 3) {
      console.log(SearchValue);
      onSearchValue(SearchValue);
      setError(false);
    } else {
      setError(true);
    }
  };

  const handleSearch = (value) => {
    if (value.length >= 3) {
      console.log(value);
      onSearchValue(value);
      setError(false);
    } else {
      setError(true);
    }
  };

  return (
    <div className="flex flex-col">
      <div className="flex h-[35px] w-full flex-row gap-1 md:w-[180px] xl:w-[300px]">
        <input
          type="text"
          name="search"
          id="search"
          className={`w-full rounded-md border-2 p-2 transition focus:outline-none focus:ring-2 
                 focus:ring-textYellow md:w-[150px] xl:w-[300px]`}
          value={SearchValue}
          onChange={(e) => setSearchValue(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              handleSearch(e.target.value); // Call the function when Enter is pressed
            }
          }}
        />
        <div
          className="flex h-[35px] cursor-pointer items-center rounded-md bg-gray-500 p-2"
          onClick={handleAdvanceSearch}
        >
          <FaSearch className="text-bgWhite" />
        </div>
      </div>
      {error && (
        <p className="text-xs text-red-600">minimum 3 letters required</p>
      )}
    </div>
  );
}

export default AdvanceSearch;
